import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;

export class ResetPasswordService {
    constructor() {
    }

    requestResetPassword(userName) {
        const uri = `/api/user/password-reset/init/${userName}`;
        return apiHelper.get(uri);
    }
    resendOTP(loginName, smscode) {
        const uri =`/api/sms/resend-otp?login-name=${loginName}&sms-code=${smscode}`
        return apiHelper.get(uri)
    }

    sendOTPforReset(data) {
        const uri = `/api/user/password-reset/finish`;
        return apiHelper.post(uri, data);
    }


    sendOTPforBranchActivate(data) {
        const uri = `/api/branch/password-reset/finish`;
        return apiHelper.post(uri, data);
    }

    getOtpTrigger(loginName) {
        const uri = `/api/sms/${loginName}`
        return apiHelper.post(uri);
    }
    // /api/getCategories
    // long description

    getEmailMobile(loginName) {
        const uri = `/api/user/email-validated?loginName=${loginName}`;
        return apiHelper.get(uri);
    }
}